{
  "publicConsents": {
    "brandSubtitle": "Stație consimțăminte · recepție",
    "footerDataController": "Operator date",
    "footerDpoLabel": "DPO",
    "loading": "Se încarcă…",

    "headerRefresh": "Reîmprospătează",
    "headerRefreshing": "Se verifică…",
    "headerRelease": "Eliberează tableta",
    "headerConfigure": "Configurare",
    "headerLogout": "Deconectare",

    "waitingEyebrow": "Tableta este pregătită",
    "waitingTitleLine1": "Se așteaptă",
    "waitingTitleLine2": "un pacient",
    "waitingRegisteredAs": "Această tabletă este înregistrată ca",
    "waitingRefreshHintBefore": "După ce recepția trimite un pacient pe această tabletă, apasă",
    "waitingRefreshHintAfter": "în bara de sus pentru a încărca documentele.",
    "waitingNoPatientYet": "Niciun pacient nu este încă asociat acestei tablete.",
    "waitingReleasing": "Se eliberează…",
    "waitingReleaseRetry": "Încearcă eliberarea din nou",
    "waitingChangeDevice": "Schimbă tableta",

    "setupEyebrow": "Configurare",
    "setupLocationTitleLine1": "Alege",
    "setupLocationTitleLine2": "locația",
    "setupLocationLead": "Selectează locația în care se află această tabletă. Vor fi afișate doar tabletele din locația aleasă.",
    "setupDeviceTitleLine1": "Alege",
    "setupDeviceTitleLine2": "această tabletă",
    "setupDeviceLead": "Selectează tableta care corespunde acestui dispozitiv. Alegerea este memorată pe acest dispozitiv până când o schimbi.",
    "setupLocationLabel": "Locație",
    "setupDeviceLabel": "Tabletă",
    "setupDevicesLoading": "Se încarcă lista tabletelor…",
    "setupNoDevices": "Nu există tablete configurate. Adaugă una în Structură → Configurări → Dispozitive IT.",
    "setupUnnamedLocation": "Locație fără nume",
    "setupConfirm": "Confirmă",
    "setupChangeLocation": "Schimbă locația",

    "codeEyebrow": "Bună ziua,",
    "codeTitleLine1": "Introdu codul",
    "codeTitleLine2": "de sesiune",
    "codeLead": "Pentru a accesa documentele pregătite pentru tine, introdu codul unic de 6 caractere care ți-a fost transmis.",
    "codeLabel": "Cod sesiune",
    "codeCharAriaLabel": "Caracter {{position}}",
    "codeNote": "Codul este unic, valabil 30 de minute și poate fi utilizat o singură dată. Sesiunea este criptată.",
    "codeContinue": "Continuă",
    "codeHelpTitle": "Nu ai un cod?",
    "codeHelpBody": "Codul de sesiune îți este comunicat la prezentare, de către recepție.",

    "welcomeEyebrow": "Bună ziua,",
    "welcomeLead": "Pe această tabletă vei putea citi și semna consimțămintele necesare pentru continuarea îngrijirii medicale. Te rugăm să citești cu atenție fiecare document înainte de a-l semna.",
    "welcomeIdentityConfirmed": "Identitate confirmată",
    "welcomeSessionOpen": "Sesiune deschisă",
    "welcomeSessionStation": "Stație consimțăminte recepție",
    "welcomeSessionOpenedAt": "la {{time}}, astăzi",
    "welcomeToReviewCount": "Trebuie să revizuiești {{count}} consimțăminte",
    "welcomeOptionalSuffix": " · opțional",
    "welcomeNote": "Procesul durează aproximativ 5 minute. Datele semnării (dată, oră, identitate) vor fi înregistrate în fișa ta medicală conform GDPR Art. 7.",
    "welcomeStart": "Începe revizuirea",

    "consentProgressOf": " din ",
    "consentScopeFallback": "Consimțământ",
    "consentBack": "Înapoi",
    "consentDocRead": "Text citit integral",
    "consentDocScroll": "Derulează pentru a citi tot textul",
    "consentPurposesLabel": "Scopuri de prelucrare",
    "consentPurposeMandatory": "obligatoriu",
    "consentAgreeText": "Am citit și înțeleg textul de mai sus și îmi exprim acordul în mod liber.",
    "consentAgreeSub": "Bifează manual — GDPR Art. 7 nu permite casete pre-bifate.",
    "consentSignatureLabel": "Semnătura ta",
    "consentSignatureClear": "Șterge și reia",
    "consentSignaturePlaceholder": "Semnează cu degetul sau cu stiloul pentru tabletă",
    "consentSignatureCaptured": "✓ Semnătură captată",
    "consentRefuse": "Refuz acest consimțământ",
    "consentFootIdentityBefore": "Acordul va fi înregistrat cu identitatea contului",
    "consentFootIdentityAfter": ", la data și ora curentă.",
    "consentFootWithdraw": "Poți retrage consimțământul oricând, prin recepție sau din portalul pacientului.",
    "consentNextFinish": "Finalizează",
    "consentNextOne": "Următorul consimțământ",
    "consentFormGenerated": "Formular generat",
    "consentFormGeneratedOn": "Formular generat {{date}}",

    "summaryEyebrow": "Rezumat",
    "summaryTitleLine1": "Toate documentele",
    "summaryTitleLine2": "au fost revizuite.",
    "summarySignedBy": "Semnat de",
    "summaryEditAgain": "Vreau să mai modific ceva",
    "summaryFinish": "Trimite și predă tableta",

    "handbackThanks": "Mulțumim,",
    "handbackLead": "Consimțămintele au fost înregistrate în fișa ta medicală.",
    "handbackNote": "Vă rugăm să predați tableta către recepție.",
    "handbackNewSession": "Sesiune nouă",

    "statusRevoked": "Revocat",
    "statusActive": "Activ",
    "statusToSign": "De semnat",
    "statusRefused": "Refuzat",
    "statusSigned": "Semnat",
    "statusSignedAt": "Semnat {{time}}",

    "patientIdNumberLabel": "CNP",
    "patientBornPrefix": "n.",
    "patientAgeYears": "{{count}} ani",

    "errorStoredDeviceInactive": "Tableta memorată nu mai este activă. Alege o tabletă din listă.",
    "errorDevicesLoad": "Lista tabletelor nu a putut fi încărcată. Reîncarcă pagina.",
    "errorCheckFailed": "Verificarea nu a reușit. Încearcă din nou sau anunță recepția.",
    "errorReleaseFailed": "Tableta nu a putut fi eliberată. Încearcă din nou înainte de a o înmâna altui pacient.",
    "codeValid": "✓  Cod valid. Se încarcă sesiunea ta…",
    "codeInvalid": "✕  Cod invalid sau expirat. Verifică codul primit și încearcă din nou.",
    "refuseConfirm": "Ești sigur(ă) că refuzi acest consimțământ? Poți continua cu celelalte documente."
  }
}
